import { Routes, Route, Navigate } from 'react-router-dom';
import appInfo from './app-info';
import routes from './app-routes';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { Footer } from './components';

export default function Content() {
  return (
    <SideNavBarLayout title={appInfo.title}>
      <Routes>
        {routes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={element}
          />
        ))}
        <Route
          path='*'
          element={<Navigate to='/tutorial' />}
        />
      </Routes>
      <Footer>
        <a href={'https://innkep.de/agbs/'} target="_blank" rel="noopener noreferrer" style={{ paddingRight: '10px' }}>AGBs</a><a href={'https://innkep.de/datenschutz/'} target="_blank" rel="noopener noreferrer">Datenschutz</a>
        <br />
        Copyright © 2026 - innKEP.
        <br />        
      </Footer>
    </SideNavBarLayout>
  );
}

